module.exports = __webpack_public_path__ + "img/open-source.2894a37c.jpg";